var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.item
    ? _c(
        "div",
        [
          _setup.formId
            ? _c(_setup.Form, {
                attrs: { "form-id": _setup.formId, "show-legends": true },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "clearfix text-center mt-3" },
            [
              _c(_setup.FormSaveBtn, {
                attrs: { "button-text": "Save", "form-id": _setup.formId },
              }),
              _vm._v(" "),
              _setup.item.id
                ? _c(
                    _setup.Button,
                    {
                      nativeOn: {
                        click: function ($event) {
                          return _setup.confirmDelete($event, _setup.item)
                        },
                      },
                    },
                    [_vm._v("\n            Delete\n        ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }